@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

$background-image-width: 56rem;
$background-image-height: 52rem;

.inngang-wrapper {
  @media (max-width: map.get($grid-breakpoints, xl)) {
    padding-top: 3.75rem;
  }
}

.text {
  max-width: 25rem;
  z-index: 10;
  position: relative;
  display: inline;
  font-weight: 500;
  font-size: 2rem;
  color: #fffaf1;
  line-height: 2.8rem;
  margin: 0;
  white-space: pre-line;
  vertical-align: bottom;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    margin: 0 0.8rem 1.8rem;
    max-width: 20.2rem;
    font-size: 1.5rem;
    line-height: 1.8rem;
  }
}

.content-wrapper {
  display: flex;
  margin: 1rem 0 3rem;
  column-gap: 1.56rem;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    margin: 0.5rem 0 3.35rem;
    flex-direction: column;
  }
}

.buttons-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    align-items: flex-start;
  }
}

.inngang-buttons-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    row-gap: 0.5rem;
  }
}

.inngang-buttons-text-1,
.inngang-buttons-text-2 {
  display: block;
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 28px;
  color: #000;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    font-size: 18px;
    font-weight: 500;
    line-height: 21.6px;
    margin-right: 1rem;
  }
}

.verktoy {
  &-wrapper {
    color: #fff;
    font-size: 20px;
    line-height: 28px;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 18px;
      line-height: 23px;
      max-width: 25rem;
    }
  }

  &-section {
    margin-bottom: 1rem;

    &--bold {
      font-weight: 600;
    }
  }

  &-button {
    display: inline;
    color: #ffdbb3;
    background: unset;
    border: none;
    font-size: 20px;
    line-height: 28px;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
    margin: 0;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 18px;
      line-height: 23px;
    }

    &:focus {
      outline: #ffdbb3 auto 1px;
    }
  }
}
